var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end mt-3 mb-4"
  }, [false ? _c('div', [_c('b-button', {
    staticClass: "ml-0 ml-xl-4",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('span', {
    staticClass: "mdi mdi-file-excel mr-1"
  }), _vm._v(" 匯出 Excel ")])], 1) : _vm._e(), _c('b-input-group', {
    staticClass: "ml-4",
    staticStyle: {
      "width": "320px"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋會員名稱、LINE UID、手機號碼"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.results,
      "fields": _vm.fields,
      "busy": _vm.loading
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [data.item.source === 'liff' ? _c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1) : _c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [data.item.source === 'liff' ? _c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.name) + " ")]) : _c('span', [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }